module.exports = __webpack_public_path__ + "static/img/數學師資介紹.ed6e01cd.png";